import upperFirst from 'lodash.upperfirst';
import lowerFirst from 'lodash.lowerfirst';

export const getCurrencyCase = (
  { name: sName, code: sCode, type: sType, ...sRest },
  { name: tName, code: tCode, type: tType, ...tRest },
  suffix
) => {
  const upSuffix = upperFirst(suffix);
  const sNameAcc = sRest[`name${upSuffix}`];
  const tNameAcc = tRest[`name${upSuffix}`];

  if ((sType === 'money' && !sNameAcc) || (tType === 'money' && !tNameAcc)) {
    return {
      [`currency${upSuffix}S`]: sCode,
      [`currency${upSuffix}T`]: tCode,
      [`currency${upSuffix}SU`]: sCode,
      [`currency${upSuffix}TU`]: tCode,
    };
  }

  const sCase =
    !sNameAcc || sType === 'crypto' ? (sName || '').toLowerCase() : sNameAcc;
  const tCase =
    !tNameAcc || tType === 'crypto' ? (tName || '').toLowerCase() : tNameAcc;

  return {
    [`currency${upSuffix}S`]: sCase,
    [`currency${upSuffix}T`]: tCase,
    [`currency${upSuffix}SU`]: upperFirst(sCase),
    [`currency${upSuffix}TU`]: upperFirst(tCase),
  };
};

const getCurrencyCaseCode = (value, upSuffix = '') => {
  const preparedValue = Math.round(Math.abs(value));
  const stringValue = `${preparedValue}`;
  const gpRegExp = /(1[1-4]|1?[5-9]|0)$/;
  const accRegExp = /1$/;
  const gp2RegExp = /(2|3|4)$/;

  /**
   * эта проверка должна идти первой
   */
  if (gpRegExp.test(stringValue)) {
    return 'nameGp';
  }

  if (accRegExp.test(stringValue)) {
    return `name${upSuffix}`;
  }

  if (gp2RegExp.test(stringValue)) {
    return 'nameGp2';
  }

  return null;
};

export const getCurrencyCaseByValue = (
  { code: sCode, type: sType, ...sRest },
  { code: tCode, type: tType, ...tRest },
  value,
  suffix = ''
) => {
  const upSuffix = upperFirst(suffix);
  const caseCode = getCurrencyCaseCode(value, upSuffix);
  const sNameByCase = sRest[caseCode];
  const tNameByCase = tRest[caseCode];

  if (
    (sType === 'money' && !sNameByCase) ||
    (tType === 'money' && !tNameByCase)
  ) {
    return {
      [`currencyValueCase${upSuffix}S`]: sCode,
      [`currencyValueCase${upSuffix}T`]: tCode,
      [`currencyValueCase${upSuffix}SU`]: sCode,
      [`currencyValueCase${upSuffix}TU`]: tCode,
    };
  }

  const sCase =
    !sNameByCase || sType === 'crypto' ? sRest.name || '' : sNameByCase;
  const tCase =
    !tNameByCase || tType === 'crypto' ? sRest.name || '' : tNameByCase;

  return {
    [`currencyValueCase${upSuffix}S`]: lowerFirst(sCase),
    [`currencyValueCase${upSuffix}T`]: lowerFirst(tCase),
    [`currencyValueCase${upSuffix}SU`]: upperFirst(sCase),
    [`currencyValueCase${upSuffix}TU`]: upperFirst(tCase),
  };
};
